/**
 * kevia-signals — Operational Signal Engine (FASE 18.1–18.2)
 *
 * Detects behavioral patterns from the runtime event timeline and
 * converts them into scored, typed operational signals.
 *
 * These signals feed:
 *  - getOperationalMode()   in runtimeSelectors (which mode is Kevia in?)
 *  - resolveKeviaSuggestions (signal-aware welcome suggestions)
 *  - generateSessionInsights (kevia-insights — passive insight card)
 *  - window.__KEVIA_RUNTIME__.getSignals() (dev debug surface)
 *
 * Dep rule: this module imports ONLY from kevia-runtime/sessionTimeline
 * and kevia-runtime/runtimeEvents — never from runtimeSelectors.
 * This prevents circular imports.
 */

export { SIGNALS, SIGNAL_META } from "./signalDefinitions";
export { computeSignals }       from "./detectOperationalSignals";

import { computeSignals as _computeSignals } from "./detectOperationalSignals";

/**
 * Returns currently active signals sorted by score (highest first).
 * Pure recomputation — safe to call on every render if needed.
 *
 * @returns {Signal[]}
 */
export function getActiveSignals() {
  return _computeSignals();
}
